import Components from "../../components/components";
import IntroPopup from "../../components/promo-popups/intro-popup";
import Layers from "../../graphics/layers/layers";
import CampaignsModel from "../../integration/revolver/model/campaigns-model";
import SmartButton, {SmartButtonFlag} from "../../smart-button/smart-button";

export const showPFSIntro = () => {
    if (CampaignsModel.getHasShownPrompt() || !CampaignsModel.isFreespinsActive()) {
        return;
    }

    CampaignsModel.setHasShownPrompt(true);
    Layers.BetBar.hide();
    Layers.PromoBetBar.hide();
    Layers.SmartButton.hide();

    const intro = Components.promoPopups.get("intro") as IntroPopup;
    intro.show().then(() => {
        SmartButton.setFlag(SmartButtonFlag.IDLE, false);
        SmartButton.setFlag(SmartButtonFlag.FREE_SPINS, true);

        // If recovered, let games handle layers themselves
        Layers.PromoBetBar.show();
        Layers.SmartButton.show();
    });
};



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/commands/promo-free-spins/show-pfs-intro.ts